/** Circular M/S badge (collapsed). */
export const MEAL_SNACK_TAG_SHORT_SIZE = 20;
export const MEAL_SNACK_TAG_BORDER_RADIUS = 10;
export const MEAL_SNACK_TAG_OVERLAY_BG = 'rgba(0,0,0,0.6)';
export const MEAL_SNACK_TAG_OVERLAY_BG_HALF = 'rgba(0,0,0,0.3)';

/** Detail expand control (bottom-trailing image corner). */
export const MEAL_SNACK_TAG_EXPAND_BTN_SIZE = 26;
export const MEAL_SNACK_TAG_EXPAND_BTN_RADIUS = 13;
export const MEAL_SNACK_TAG_EXPAND_ICON_SIZE = 13;

/** Stable long-tag width without onLayout (avoids 1-frame flicker). Caps width for FlatList scroll performance. */
export function estimateMealSnackTagLongWidth(label: string): number {
  const char_width_est = 7;
  const padding_h = 14;
  const width_min = 36;
  const width_max = 120;
  return Math.min(width_max, Math.max(width_min, label.length * char_width_est + padding_h));
}
